





































































import {DATE_FORMAT, DATE_FORMAT_JA} from "@/common/constant";
import qNotify from "@/common/qNotify";
import ContractMoveOut from "@/model/contractMoveOut";
import moment from "moment";
import {Component, Vue, Watch} from "vue-property-decorator";
import { namespace } from "vuex-class";
import QCalendar from "@/common/qCalendar.vue";

const moveOutStore = namespace("MoveOut");
@Component({
  name: "MovingDetail",
  components: {QCalendar},
})
export default class MovingDetail extends Vue {
  @moveOutStore.Getter
  getMoveOut!: ContractMoveOut;

  public moveOutClone = new ContractMoveOut()
  public dateConfig = {
    minDate: moment().format(DATE_FORMAT)
  };

  @Watch('moveOutClone.moving_out_date')
  editMoveOutDate() {
    this.$emit('moveOut', this.moveOutClone)
  }

  mounted() {
    if (this.getMoveOut.isTranfered) {
      qNotify.error({
        text: this.$t("data_was_transfered"),
      });
      this.$router.push({ name: "admin.contract-moving" });
    }

    this.moveOutClone = JSON.parse(JSON.stringify(this.getMoveOut))
  }
  get today() {
    return moment().format(DATE_FORMAT_JA);
  }
}
